import { render } from "./PayslipPage.vue?vue&type=template&id=d1a180b4&scoped=true"
import script from "./PayslipPage.vue?vue&type=script&lang=js"
export * from "./PayslipPage.vue?vue&type=script&lang=js"

import "./PayslipPage.vue?vue&type=style&index=0&id=d1a180b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a180b4"]])

export default __exports__